import autobahn from "autobahn";
import Axios from 'axios';
import jwtDecode from 'jwt-decode';
import moment from 'moment';
import pako from 'pako';
import atob from 'atob';
import btoa from "btoa";
import AuthService from "./authServise";
import { webConfig } from '../config';

export default class DeviceService {

  //for simulate api call
  sleep = (ms) => {
    return new Promise((resolve) => setTimeout(resolve, ms));
  };

  isLocalRemoteSessionValid(gatwayId) {
    let tokenIsValid = false;
    const key = webConfig.LOCAL_STORAGE_REMOTE_SESSION_KEY + "_" + gatwayId;
    const session = localStorage.getItem(key);

    if (session) {
      const remoteSession = JSON.parse(session);

      if (remoteSession && remoteSession.expiresAt) {
        const expireTime = new Date(remoteSession.expiresAt);
        const now = new Date();
        if (expireTime > now) {
          tokenIsValid = true;
        }
      }
    }

    return tokenIsValid;
  }


  async createRemoteSession(gatwayId) {
    const authServise = new AuthService();
    const currentSession = authServise.getCurrentSession();

    const result = await Axios.create({
      baseURL: webConfig.API_HOST,
      timeout: 30000,
      headers: { Authorization: 'Bearer ' + currentSession.accessToken },
    }).post('/auth/remote_access', { "gateway_id": gatwayId });
    const remoteSession = {
      accessToken: result.data.access_token,
      expiresAt:
        moment
          .utc()
          .add(result.data.expires_at, 'seconds')
          .unix() * 1000, // do it in utc
    }

    const key = webConfig.LOCAL_STORAGE_REMOTE_SESSION_KEY + "_" + gatwayId;

    localStorage.setItem(
      key,
      JSON.stringify(remoteSession),
    );

  }

  async getRemoteToken(gatwayId) {

    try {
      const key = webConfig.LOCAL_STORAGE_REMOTE_SESSION_KEY + "_" + gatwayId;

      if (this.isLocalRemoteSessionValid()) {
        const remoteSession = JSON.parse(localStorage.getItem(key));
        return remoteSession.accessToken;
      } else {
        await this.createRemoteSession(gatwayId);
        const remoteSession = JSON.parse(localStorage.getItem(key));
        return remoteSession.accessToken;
      }
    } catch (error) {
      console.log("ERROR: ", error);
      return null;
    }
  }

  async getAutobahnConnection(gatwayId) {

    const url = webConfig.AUTOBAHN_CONNECTION;
    const urlHack = webConfig.AUTOBAHN_CONNECTION_CHROME_HACK;
    let accessToken = await this.getRemoteToken(gatwayId);

    let connection = new autobahn.Connection({
      url: url,
      realm: "com.digitallumens",
      authmethods: ["ticket"],
      authid: "no_id",
      onchallenge: async function (session, method, extra) {
        // eslint-disable-next-line no-lone-blocks
        {
          try {
            if (method === "ticket" && accessToken) {
              return accessToken;
            } else {
              // eslint-disable-next-line no-throw-literal
              throw "don't know how to authenticate using '" + method + "'";
            }
          } catch (error) {
            console.log("ERROR:", error);
            return null;
          }
        };
      },
    });
    // !!!HACK!!! ONLY FOR google chrome to get autobahn connected
    Axios.request(urlHack).catch(() => { });

    return connection;
  }

  async getAutobahnConnectionForStatus(userToken) {
    const url = webConfig.AUTOBAHN_CONNECTION;
    const urlHack = webConfig.AUTOBAHN_CONNECTION_CHROME_HACK;

    let connection = new autobahn.Connection({
      url: url,
      realm: "com.digitallumens",
      authmethods: ["ticket"],
      authid: "no_id",
      onchallenge: async function (session, method, extra) {
        // eslint-disable-next-line no-lone-blocks
        {
          try {
            if (method === "ticket" && userToken) {
              return userToken;
            } else {
              // eslint-disable-next-line no-throw-literal
              throw "don't know how to authenticate using '" + method + "'";
            }
          } catch (error) {
            console.log("ERROR:", error);
            return null;
          }
        };
      },
    });
    // !!!HACK!!! ONLY FOR google chrome to get autobahn connected
    Axios.request(urlHack).catch(() => { });

    return connection;
  }

  openStatusConnection(callbackOnOpen, callbackOnClose, userToken) {

    this.getAutobahnConnectionForStatus(userToken).then(conn => {
      if (conn === null) {
        return null;
      }

      conn.onopen = callbackOnOpen;
      conn.onclose = callbackOnClose;
      conn.open();
    });

  }


  openConnection(callbackOnOpen, callbackOnClose, gatwayId) {

    this.getAutobahnConnection(gatwayId).then(conn => {
      if (conn === null) {
        return null;
      }

      conn.onopen = callbackOnOpen;
      conn.onclose = callbackOnClose;
      conn.open();
    });

  }

  closeConnection(reason, details) {
    console.log("connection closed:", reason, details);
  }

  async readFile(file) {
    return new Promise((resolve, reject) => {
      // Create file reader
      let reader = new FileReader()

      // Register event listeners
      reader.addEventListener("loadend", e => resolve(e.target.result))
      reader.addEventListener("error", reject)

      // Read file
      reader.readAsArrayBuffer(file)
    })
  }

  async getAsByteArray(file) {
    const arrayBuffer = await this.readFile(file)
    return new Uint8Array(arrayBuffer);
  }

  async blobToBase64(blob) {
    return new Promise((resolve, _) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.readAsDataURL(blob);
    });
  }

  uint8ToBase64(buffer) {
    var binary = '';
    var len = buffer.byteLength;
    for (var i = 0; i < len; i++) {
      binary += String.fromCharCode(buffer[i]);
    }
    return btoa(binary);
  }

  async upload(file, gatwayId) {

    if (!file || !gatwayId) {
      return null;
    }

    const timeOut = moment().add(10, 'seconds');

    let retVal = null;
    let wait = true;

    const input = await this.getAsByteArray(file);
    const zipData = pako.deflate(input);
    let base64Data = this.uint8ToBase64(zipData);

    this.openConnection((session) => {

      const uri = 'com.digitallumens.gateway-' + gatwayId;
      const request = {
        "action": "GET",
        "params": {
          "headers": 'Content-Type:application/octet-stream',
          "body": base64Data,
          "method": "POST",
          "path": "/api/bmsapi/service/upload/upload-file",
          "port": "27021",
          "compression": "zlib"
        },
        "resourceId": "/dalipro/rest-tunnel"
      }

      session.call(uri, [request]).then(result => {
        if (result.args[0].results.httpStatusCode === 200) {
          retVal = "DONE";
          wait = false;

          const startUploadRequest = {
            "action": "GET",
            "params": {
              "body": "",
              "method": "POST",
              "path": "/api/bmsapi/service/upload/start",
              "port": "27021",
              "compression": "none"
            },
            "resourceId": "/dalipro/rest-tunnel"
          }
          session.call(uri, [startUploadRequest]).then(result => {
            //console.log(result);
          });
        }

      });
    }, function (reason, details) {
      console.log("connection closed:", reason, details);
      retVal = "ERROR";
      wait = false;
    }, gatwayId);

    while (wait && moment() < timeOut) {
      //wait for data
      await this.sleep(3000);
    }

    if(retVal === null){
      retVal = "ERROR";
    }

    return retVal;
  }

  async getDeviceConnectionStatus(gatwayId, userToken) {
    const timeOut = moment().add(60, 'seconds');
    let wait = true;

    let state = {online: false, lastConnection:"" }
    if (!gatwayId) {
      return null;
    }

      this.openStatusConnection(async (session) => {
        const uri = 'com.digitallumens.monitor-service.connectivitystate';
        const kwargs = {
          "token":     userToken,
          "procedure": "getGatewayConnectivityState",
          "id":        gatwayId,
        }

        const result = await session.call(uri, [], kwargs);
        
        state.online = result.kwargs.connected;
        if(result.kwargs.last)
        {
          state.lastConnection = moment(result.kwargs.last).format("DD/MM/YYYY (HH:mm:SS)");
        }else{
          state.lastConnection = " NO DATE";
        }

        wait = false;
        return state;
  
      }, function (reason, details) {
        console.log("connection closed:", reason, details);
        wait = false }, userToken);
    

    while (wait && moment() < timeOut) {
      //wait for data
      await this.sleep(250);
    }

    return state;
  }

  async download(gatwayId) {

    if (!gatwayId) {
      return null;
    }

    const timeOut = moment().add(10, 'seconds');

    const uri = 'com.digitallumens.gateway-' + gatwayId;
    let data = null;
    let wait = true;

    this.openConnection(async (session) => {
     
      const downloadRequest = {
        "action": "GET",
        "params": {
          "body": "",
          "method": "GET",
          "path": "/api/bmsapi/service/device-search/result-file",
          "port": "27021",
          "compression": "zlib"
        },
        "resourceId": "/dalipro/rest-tunnel"
      }

      session.call(uri, [downloadRequest]).then(result => {
        try {
         
          var base64Data = result.args[0].results.body;
          var strData = atob(base64Data);

          // Convert binary string to character-number array
          var charData = strData.split('').map(function (x) { return x.charCodeAt(0); });

          // Turn number array into byte-array
          var binData = new Uint8Array(charData);

          // Pako magic
          var pakoData = pako.inflate(binData);
          data = pakoData;
          wait = false;
          return pakoData;

        } catch (error) {
          console.log("ERROR:", error);
          wait = false;
        }
      })
    }, function (reason, details) {
      console.log("connection closed:", reason, details);
      wait = false;
    }, gatwayId)

    while (wait && moment() < timeOut) {
      //wait for data
      await this.sleep(250);
    }

    return data;
  }
}
